/** 1019 becomes "1 019": a no-break space (U+00A0) between the thousands. */
export function withThousands(count: number): string {
  return String(count).replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0");
}
